import { render, staticRenderFns } from "./AlgoliaMultiValueFacet.vue?vue&type=template&id=1007d1cc&scoped=true"
import script from "./AlgoliaMultiValueFacet.vue?vue&type=script&lang=js"
export * from "./AlgoliaMultiValueFacet.vue?vue&type=script&lang=js"
import style0 from "./AlgoliaMultiValueFacet.vue?vue&type=style&index=0&id=1007d1cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1007d1cc",
  null
  
)

export default component.exports